import type {
    Form as FormComponent,
    StyleFunction,
} from "@venuepos/react-common";
import {
    Button,
    CheckBox,
    InputControl,
    Loading,
    Surface,
    TextInput,
    useThemedStyle,
} from "@venuepos/react-common";
import type { GQApprovalTokenGroupInput } from "graphql-sdk";
import { useApprovalTokenGroupFormQuery } from "graphql-sdk";
import { useTranslation } from "locales";
import React from "react";

export function Form(props: {
    form: FormComponent<GQApprovalTokenGroupInput>;
    onSubmit: () => void;
    submitButton: [string, string];
}) {
    const [t] = useTranslation();
    const [{ values, errors }, { setValue, handleSubmit }] = props.form;
    const styles = useThemedStyle(styleFunc);
    const { data, loading } = useApprovalTokenGroupFormQuery();

    if (loading) {
        return <Loading />;
    }

    if (!values || !data) {
        return null;
    }

    return (
        <>
            <Surface style={styles.surfaceContainer}>
                <InputControl
                    error={errors.name}
                    description={t(
                        "backoffice.approval_token_group.name_description",
                        "The name of the approval token group"
                    )}
                >
                    <TextInput
                        label={t("common.name", "Name")}
                        placeholder={t(
                            "backoffice.common.enter_name",
                            "Enter name"
                        )}
                        required={true}
                        defaultValue={values.name || ""}
                        onChangeText={text => setValue("name", text)}
                    />
                </InputControl>
                <InputControl
                    error={errors.active}
                    description={t(
                        "backoffice.approval_token_group.active_description",
                        "Should the approval token group be active or not"
                    )}
                >
                    <CheckBox
                        label={t("common.active", "Active")}
                        value={values.active}
                        onValueChange={checked => setValue("active", checked)}
                        testID="active"
                    />
                </InputControl>

                <Button onPress={handleSubmit(props.onSubmit)}>
                    {t(props.submitButton[0], props.submitButton[1])}
                </Button>
            </Surface>
        </>
    );
}

const styleFunc: StyleFunction = theme => ({
    surfaceContainer: {
        marginVertical: theme.spacingScale / 2,
    },
});
